module.exports = __webpack_public_path__ + "img/robot-leg.dce9f8d1.svg";